<template>
  <div>
    <page-header
      :page="pageConfig"
      left-side-class="col-md-4 col-sm-12"
      right-side-class="col-md-8 col-sm-12"
      class="page-header__extended"
    >
      <detail-header-buttons
        :status-id="this.info.status"
        :delete-submit-actions-visible="!submitReportFlag"
        @on-download-dans-excel-report="getDetailDansReport(true)"
        @on-download-dans-word-report="getDetailDansReport(false)"
        @on-download-details-report="getDetailReport"
        @on-update="onUpdateReportHandler"
        @on-generate-files="generateFiles"
        @on-delete-files="deleteFiles"
        @on-submit="submitReportFlag = true"
      />
    </page-header>

    <submit-form
      v-if="submitReportFlag"
      @on-cancel="submitReportFlag = false"
      @on-submit="submitReport"
    />
    <board :details="detailsBoard" />
    <report-detail
      :collections="collections"
      v-if="isNewStatus"
      :summary="summary"
      @on-get-detail="getDetail"
    />

    <custom-tab
      v-if="isGeneratedFileStatus || isSubmittedStatus"
      class="mt-2 "
      content-class=" text-center"
      nav-class="custom-nav-container mx-0 "
      :no-nav-style="true"
    >
      <custom-tab-item lazy title="Datos">
        <report-detail
          :collections="collections"
          :summary="summary"
          @on-get-detail="getDetail"
        />
      </custom-tab-item>
      <custom-tab-item active lazy title="Archivos">
        <file-container
          :files="files"
          :allow-to-submit="isSubmittedStatus"
          @on-download-file="onDownloadFileHandler"
          @on-amend-file="onAmendFileHandler($event)"
        />      
      </custom-tab-item>
    </custom-tab>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import Board from 'Board'
import ReportDetail from './components/ReportDetail.vue'
import Service from '@/services/api/edenexit.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@/modules/report/document'
import edenStatus from '@/utils/constants/edenStatus.js'
import DetailHeaderButtons from '../shared/components/DetailHeaderButtons.vue'
import SubmitForm from '../shared/components/SubmitForm.vue'
import { CustomTab, CustomTabItem } from 'custom-tabs'
import FileContainer from "@/views/eden/shared/components/file/FileContainer.vue";

export default {
  name: 'EdenDetails',
  components: {
    PageHeader,
    Board,    
    FileContainer,
    ReportDetail,
    CustomTab,
    CustomTabItem,
    DetailHeaderButtons,
    SubmitForm,
  },
  data: () => ({
    submitReportFlag: false,
    submitDate: null,
    info: {
      id: null,
      academicYear: null,
      statusName: null,
      status: null,
      lastUpdatedDate: null,
    },
    summary: {
      totalExitCount: 0,
      lastYearDifferenceCount: 0,
      graduateWithDiplomaCounter: {
        count: 0,
      },
      receivedCertificateCounter: {
        count: 0,
      },
      reachedMaximumAgeCounter: {
        count: 0,
      },
    },
    files: [],
    collections: {
      exitTypes: [],
      ethnicGroups: [],
      ages: [],
      genders: [],
      impediments: [],
      languagesProficiency: [],
      alerts: [],
    },
  }),
  computed: {
    isGeneratedFileStatus() {
      return this.info.status == edenStatus.GENERATED_FILE
    },
    isNewStatus() {
      return this.info.status == edenStatus.NEW
    },
    isSubmittedStatus() {
      return this.info.status == edenStatus.SUBMITTED
    },
    pageConfig() {
      return {
        title: 'Egreso',
        icon: 'fas fa-calculator',
        routes: ['Inicio', '618 Data', 'Egreso'],
      }
    },
    detailsBoard() {
      return [
        [
          {
            label: 'Año Académico',
            icon: 'fas fa-calendar-edit',
            data: this.info.academicYear,
            cols: 'col-12 col-md',
          },
          {
            label: 'Estatus:',
            icon: 'fas fa-ballot-check',
            data: this.info.statusName,
            cols: 'col-12 col-md',
          },
          {
            label: 'Actualizado al:',
            icon: 'fas fa-calendar-edit',
            data: this.$options.filters.date(this.info.lastUpdatedDate),
            cols: 'col-12 col-md',
          },
        ],
      ]
    },
    edenMasterId() {
      return this.$route.params.id
    },
  },
  async mounted() {
    await this.getDetail();
    if (this.isGeneratedFileStatus || this.isSubmittedStatus) {
      await this.getFiles();
    }        
  },
  methods: {
    async getDetail() {
      const { data } = await Service.getDetail(this.edenMasterId)
      if (data) {
        this.info = {
          id: data.id,
          academicYear: data.academicYear.name,
          statusName: data.status.name,
          status: data.status.id,
          lastUpdatedDate: data.lastUpdatedDate,
        }
        this.summary = data.summary
        this.collections = data.filters
      }
    },
    async generateFiles() {
      await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea generar los archivos del Año Académico ${this.info.academicYear}?`,
        'Sí',
        'No'
      ).then(async (answer) => {
        if (!answer) return

        Service.generateFiles(this.edenMasterId)
          .then(async ({ data }) => {
            if (data) {
              await this.getDetail();
              await this.getFiles();
            }
          })
          .catch((err) => {
            this.ShowToast('', err.response?.data?.message, 'error')
          })
      })
    },
    async getFiles() {
      this.files = (await Service.getFiles(this.edenMasterId)).data;
    },
    async onUpdateReportHandler() {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea actualizar los datos del reporte?',
        'Si',
        'No'
      )
      if (!answer) return
      await Service.updateEdenExitReport(this.edenMasterId)
        .then(async ({ data }) => {
          if (data) {
            this.ShowToast(
              'Proceso Exitoso',
              'Los datos del reporte han sido actualizados exitosamente.',
              'success'
            )
            await this.getDetail()
          }
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error')
        })
    },
    async getDetailReport() {
      await ReportServices.getReport('edenexitdetail', {
        edenExitId: this.edenMasterId,
      })
        .then((res) => DocumentServices.Download(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error')
        })
    },
    async getDetailDansReport(isExcelFormat) {
      await ReportServices.getReport('edenexitdans', {
        edenMasterId: this.edenMasterId,
        isExcelFormat,
      })
        .then((res) => DocumentServices.Download(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error')
        })
    },
    async submitReport(date) {
      await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea someter los archivos del Año Académico ${this.info.academicYear}?`,
        'Sí',
        'No'
      ).then(async (answer) => {
        this.submitReportFlag = false
        if (!answer) return
        await Service.submitReport({
          EdenMasterId: Number(this.edenMasterId),
          Date: date,
        })
          .then(async () => {
            this.ShowToast(
              'Confirmación',
              'El archivo ha sido sometido exitosamente.',
              'success'
            )
            await this.getDetail()
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              this.ShowToast('Error', err.response.data.message, 'error')
            } else {
              this.ShowToast('Error', err.message, 'error')
            }
          })
      })
    },
    async deleteFiles() {
      await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea eliminar los archivos del Año Académico ${this.info.academicYear}?`,
        'Sí',
        'No'
      ).then(async (answer) => {
        if (!answer) return
        await Service.deleteFiles(this.edenMasterId)
          .then(async () => {
            this.ShowToast(
              'Confirmación',
              'Los archivos han sido eliminados exitosamente.',
              'success'
            )
            await this.getDetail()
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              this.ShowToast('Error', err.response.data.message, 'error')
            } else {
              this.ShowToast('Error', err.message, 'error')
            }
          })
      })
    },
    onDownloadFileHandler(id) {
      if (id) {
        Service.getEdenFile(id)
          .then((res) => DocumentServices.Download(res.data))
          .catch((err) => {
            this.ShowToast("", err.response?.data?.message, "error");
          });
      }
    },
    async onAmendFileHandler(event)
    {
      const params = {
          edenMasterId: Number(this.edenMasterId),
          edenReportFileType: event.fileTypeId,
          amendReason: event.amendReason,
        };
        const { data } = await Service.amendReport(params);
        if (data) {
          this.ShowToast(
            "Confirmación",
            "El informe ha sido enmendado exitosamente.",
            "success"
          );
          await this.getFiles();
        }
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables/_colors.scss';
.nav-link {
  padding-left: 70px !important;
}
.no-margin {
  margin-right: 0px !important;
}

.no-tag-badge-parent {
  .tag-badge-info {
    background: none !important;
  }
  .dot {
    background-color: map-get($colors, 'green') !important;
  }
}
</style>
